import { useLang } from "@/i18n";
import Reveal from "./Reveal";

const partners = [
  {
    name: "WANKAI NEW MATERIAL",
    logo: "/brand/wkai.png",
    role: { tr: "Tedarik Ortağı", en: "Supply Partner", ru: "Партнёр по поставкам" },
    desc: { tr: "PET granül (WK801) tedarikinde global lider.", en: "Global leader in PET granule (WK801) supply.", ru: "Мировой лидер по поставкам ПЭТ гранул (WK801)." },
  },
  {
    name: "ANGEL YEAST",
    logo: "/brand/angel.png",
    role: { tr: "Tedarik Ortağı", en: "Supply Partner", ru: "Партнёр по поставкам" },
    desc: { tr: "Dünyanın önde gelen kuru maya üreticisi.", en: "One of the world's leading dry-yeast producers.", ru: "Один из ведущих мировых производителей сухих дрожжей." },
  },
  {
    name: "EPLASTMER",
    logo: "/brand/eplastmer.png",
    role: { tr: "Tedarik Ortağı", en: "Supply Partner", ru: "Партнёр по поставкам" },
    desc: { tr: "PET reçine (EP-B411) üretiminde yeni nesil materyal ortağı.", en: "Next-generation material partner for PET resin (EP-B411).", ru: "Партнёр нового поколения по ПЭТ смолам (EP-B411)." },
  },
  {
    name: "NEPTUNE LOGISTICS GROUP",
    logo: "/brand/neptune.png",
    role: { tr: "Lojistik Ortağı", en: "Logistics Partner", ru: "Логистический партнёр" },
    desc: { tr: "Çin–Orta Asya koridorunda uluslararası lojistik ortağımız.", en: "Our international logistics partner across the China–Central Asia corridor.", ru: "Наш международный логистический партнёр в коридоре Китай–Центральная Азия." },
  },
];

export default function Partners() {
  const { t, lang } = useLang();
  return (
    <section id="partners" data-testid="partners" className="relative bg-[#f6f6f4] py-24 md:py-32">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#d81f2a]">
            {t("partners_overline")}
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase leading-[0.95] tracking-tight text-[#0f1115]">
            {t("partners_title")}
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {partners.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="group border border-black/10 bg-[#ffffff] p-8 h-full flex flex-col hover:border-[#d81f2a]/40 transition-colors" data-testid={`partner-${i}`}>
                <div className="bg-white h-32 flex items-center justify-center p-6">
                  <img src={p.logo} alt={`${p.name} logo`} className="max-h-full max-w-full object-contain" />
                </div>
                <div className="mt-6 flex items-center gap-2">
                  <span className="h-1.5 w-1.5 bg-[#d81f2a]" />
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#d81f2a]">{p.role[lang] || p.role.tr}</span>
                </div>
                <div className="mt-3 font-display text-lg font-bold uppercase tracking-tight text-[#0f1115] group-hover:text-[#d81f2a] transition-colors leading-tight">
                  {p.name}
                </div>
                <p className="mt-3 font-body text-sm text-[#5b6472] leading-relaxed">
                  {p.desc[lang] || p.desc.tr}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
